import { HOST } from "./host";

const USER = `${ HOST }/admin/user`;

const API = {

  sign: {

    in: `${ HOST }/admin/sign/in`,
    check: `${ HOST }/admin/sign/check`

  },

  user: {

    all: `${ USER }/all`,
    get: `${ USER }/get`,

    add: `${ USER }/add`,
    edit: `${ USER }/edit`,

    remove: `${ USER }/remove`,

  },

}

export { API };